import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { listOrders } from "../lib/api";
import StatusPill from "../components/StatusPill";
import { STATUS_LABELS, STATUS_TIMELINE, timeAgo } from "../lib/constants";

const STATUS_FILTERS = [...STATUS_TIMELINE, "revision_requested"];

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    listOrders()
      .then(setOrders)
      .catch(() => setOrders([]))
      .finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(
    () => (status === "all" ? orders : orders.filter((o) => o.status === status)),
    [orders, status]
  );

  return (
    <div data-testid="orders-page" className="max-w-7xl mx-auto px-6 py-12">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
        <div>
          <div className="cc-overline">Marketplace</div>
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-white mt-2">Orders</h1>
        </div>
        <div className="flex items-center gap-1.5 flex-wrap">
          <button onClick={() => setStatus("all")} data-testid="filter-status-all" className={`cc-pill ${status === "all" ? "active" : ""}`}>All</button>
          {STATUS_FILTERS.map((s) => (
            <button
              key={s}
              onClick={() => setStatus(s)}
              data-testid={`filter-status-${s}`}
              className={`cc-pill ${status === s ? "active" : ""}`}
            >
              {STATUS_LABELS[s]}
            </button>
          ))}
        </div>
      </div>

      <div className="cc-surface rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-widest text-[#606070] border-b border-[#15152a]">
              <th className="px-5 py-4">Order ID</th>
              <th className="px-5 py-4">Company</th>
              <th className="px-5 py-4">Creator</th>
              <th className="px-5 py-4">Type</th>
              <th className="px-5 py-4">Game</th>
              <th className="px-5 py-4">Status</th>
              <th className="px-5 py-4 text-right">Price</th>
              <th className="px-5 py-4 text-right">Created</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr><td colSpan={8} className="px-5 py-8 text-center text-[#606070]">Loading…</td></tr>
            )}
            {!loading && filtered.length === 0 && (
              <tr><td colSpan={8} className="px-5 py-8 text-center text-[#606070]">No orders.</td></tr>
            )}
            {filtered.map((o) => (
              <tr
                key={o.id}
                data-testid={`order-row-${o.id}`}
                className="border-b border-[#15152a] hover:bg-[#0a0a14]/50 transition-colors"
              >
                <td className="px-5 py-4">
                  <Link to={`/orders/${o.id}`} className="font-mono text-[#00ff88] hover:underline">{o.id}</Link>
                </td>
                <td className="px-5 py-4 text-white">{o.company_name}</td>
                <td className="px-5 py-4 text-white">{o.creator_name}</td>
                <td className="px-5 py-4 text-[#a0a0b0]">{o.content_type}</td>
                <td className="px-5 py-4 text-[#a0a0b0]">{o.game}</td>
                <td className="px-5 py-4"><StatusPill status={o.status} /></td>
                <td className="px-5 py-4 text-right font-mono text-[#00ff88]">${o.price}</td>
                <td className="px-5 py-4 text-right text-[11px] text-[#606070]">{timeAgo(o.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
